import { render, staticRenderFns } from "./homeStudentTitleCard.vue?vue&type=template&id=41c4ee4a&scoped=true&"
import script from "./homeStudentTitleCard.vue?vue&type=script&lang=js&"
export * from "./homeStudentTitleCard.vue?vue&type=script&lang=js&"
import style0 from "./homeStudentTitleCard.vue?vue&type=style&index=0&id=41c4ee4a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c4ee4a",
  null
  
)

export default component.exports